<template>
  <div class="bast">
    <div class="file-section">
      <span v-if="!isAdmin && images.length == 0">No BAST for approval yet</span>
      <div v-if="!isLoading" :class="[images.length == 0 ? 'bast-wrapper-default' :'bast-wrapper']"> 
        <adx-gallery-slideshow 
        :images="images" :wrapperStyle="wrapperStyle" :title="tempUrl"
        :imageStyle="imageStyle" @downloadedImg="downloadImg" :urlImg="tempUrl"
        :eyeIconStyle="eyeIconStyle" @deletedImage="delImage"/>
      </div>
      <div v-else class="media__loading">
        <loading-secondary/>
      </div>
      <div v-if="isAdmin" class="upload-box" @click="launchFilePicker()">
        <input 
          type="file"
          accept=".jpg, .jpeg, .png, .zip, .rar, .pdf" 
          @change="getFile($event)" 
          ref="fileUpload"
          :name="`fileUpload`" 
          :id="`fileUpload`" 
          style="display: none;">
        <span >Browse file to upload</span>
      </div>
      <div>
        <button 
          v-if="images.length && isAdmin" 
          class="btn-small primary mockup" 
          @click.stop="toggleModal(1)">
            Send BAST File
        </button>
      </div>
    </div>
    <!-- Modal -->
    <modal v-if="isBastModal"  :noTitle="true" @modal-close="toggleModal(1)" :type="'small'">
      <div class="bast__bast-modal" slot="content">
        <h2 class="medium-title">BAST Already Sent</h2>
          <div class="label">
            <span>You already sent the BAST before, are you sure want to resend the BAST?</span>
          </div>
          <div class="bast__bast-modal__buttons" >
            <button class="btn-large primary resend" @click.stop="resendBast(1)">Resend</button>
            <button class="btn-large primary cancel btn-white" @click.stop="toggleModal(1)">Cancel</button>
        </div>
      </div>
      </modal>
      <modal v-if="isReject" :noTitle="true" @modal-close="toggleModal(2)" :type="'small'">
        <div class="bast__bast-modal" slot="content">
            <h2 class="medium-title">Reason for Rejection</h2>
            <div class="label">
              <span>Please tell us the reason for rejection and we will back with the new mockup in the next 24 hours.</span>
            </div>
            <div class="label">
              <adx-input :label="`Leave a message`" :value.sync="rejectMessage"/>
            </div>
          <div class="bast__bast-modal__buttons" >
            <button class="btn-large primary resend" @click.stop="resendBast(2)">Submit</button>
          </div>
        </div>
      </modal>
      <adx-top-alert ref="alert" :status="status" :message="message" visible="visible"/>
  </div>
</template>

<script>

import GallerySlideShow from '@/components/GallerySlideShow'
import Modal from '@/components/Modal'
import Media from 'vue-media'
import file from '@/components/File'
import Input from '@/components/Form/Input'
import LoadingSecondary from '@/components/Loading/Secondary'
import TopAlert from '@/components/AlertWide'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters } from 'vuex';
import { parseErrorGql } from '@/lib/error'

export default {
  name: 'adx-',
  components: {
    'adx-gallery-slideshow': GallerySlideShow,
    'modal': Modal,
    'media': Media,
    "adx-file": file,
    'adx-input': Input,
    'adx-top-alert': TopAlert,
    'loading-secondary': LoadingSecondary,
  },
  props: {

  },
  data() {
    return {
      isBastModal: false,
      isReject: false,
      status:"Success!",
      message:"Your file has sent successfully",
      visible:true,
      rejectMessage: '',
      imageIds: [],
      images: [],
      imagesDownload: [],
      id: null,
      title: null,
      totalPrice: 0,
      isLoading: false,
      isAdmin: null,
      imageStyle: {
        "width": "132px",
        "height": "132px",
        "margin-bottom": "24px"
      },
      wrapperStyle: {
        "display": "grid",
        "grid-gap": "24px 0px",
        "grid-template-columns": "repeat(4, minmax(150px, 1fr))"
      },
      eyeIconStyle: {
        "font-size": "28px",
        "margin": "0",
        "position": "absolute",
        "top": "calc(50% - 10px)",
        "left": "calc(50% - 10px)"
      },
      pdfIcon: '/img/adxicon/placeholder-pdf.png',
      zipIcon: '/img/adxicon/placeholder-zip.png',
      rarIcon: '/img/adxicon/placeholder-rar.png',
      tempImg: [],
      tempUrl: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'account',
      token: 'token'
    })
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.id = this.$route.params.id
    this.busOrder()
  },
  mounted() {
    localStorage.setItem('apollo-token', this.token)
    this.isAdmin = this.user.isStaff
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async busOrder(){
      this.isLoading = true
      const data = await this.$apollo.query({
        query:require('@/graphql/bus/busOrderDetail.gql'),
        loadingKey:'loading',
        errorPolicy:'all',
        fetchPolicy:'network-only',
        variables:{
          id: this.$route.params.id
        }
      })
      if (data.data){
        if (data.errors){
          this.handleError(data.errors)
        } else{
          const { busOrder } = await data.data
          if (busOrder) {
            await this.mapData(busOrder)
          }
        }
        this.isLoading = false
      }
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          this.count++
          if (this.count<3) {
            await this.busCampaign()
          } else{
            this.showNotification()
          } 
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    showNotification(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    },
    async mapData(busOrder){
      this.images = []
      this.tempUrl = []
      this.imageIds = []
      await busOrder.bast.forEach(element => {
        let type = element.content_url.substring(name.lastIndexOf('.')+1)
        let ImgDisplay = this.getImgDisplay(element.content_url, type)
        this.images.push(ImgDisplay)
        this.tempUrl.push(element.content_url)
        this.imageIds.push(parseInt(element.id));
      });
    },
    launchFilePicker() {
      this.$refs.fileUpload.click()
    },
    delImage(index) {
      this.images.splice(index, 1)
      this.tempUrl.splice(index, 1)
      this.imageIds.splice(index, 1)
      this.updateOrder()
    },
    toggleModal(index) {
      if(index == 1) {
        this.isBastModal = !this.isBastModal
      } else if(index == 2) {
        this.isReject = !this.isReject
      }
    },
    getFile(event) {
      let reader = new FileReader()
      let file = event.target.files[0]
      let ImgDisplay = ''
      reader.readAsDataURL(event.target.files[0])
      reader.onload = (e) => {
        ImgDisplay = this.getImgDisplay(e.target.result, file.type )
        this.images.push(ImgDisplay)
        this.tempUrl.push(e.target.result)
        this.saveFile(event.target.files[0])
      }
    },
    getImgDisplay(img, type){
      if (/zip/.test(type)){
        return this.zipIcon
      } else if (/pdf/.test(type)){
        return this.pdfIcon
      } else if(/rar/.test(type)){
        return this.rarIcon
      } else {
        return img
      }
    },
    async saveFile(fileData) {
      let reader = new FileReader()
      this.isLoading = true
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/uploadFile.gql'),
        errorPolicy: 'all',
        variables: {
          content : {file:fileData}
        },
      });
      if (result.data && !result.errors) {
        this.imageIds.push(parseInt(result.data.uploadFile.id))
        var child = this.$refs.alert;
        child.fadeout()
      } else{
        this.errorNotify()
      }
      this.updateOrder()
    },
    async updateOrder() {
      this.isLoading = true;
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/mutation/updateBastByOrder.gql'),
        errorPolicy: 'all',
        variables: {
          id: this.id,
          busOrder: {
            fileId: this.imageIds
          }
        },
      });
      if(result.data) {
        await this.busOrder()
        this.isLoading = false;
      } else{
        this.errorNotify()
      }
    },
    downloadImg(image_data, index){
      this.$http.get(this.tempUrl[index], {
        responseType: 'arraybuffer',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET',
            // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        })
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/ptestdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = this.tempUrl[index].split('/').pop()
        link.click()
      })
    },
    resendBast(index) {
      (async () => {
        let data = {
          "id": this.id,
          "type": "done",
          "title": this.title,
          "images": this.tempUrl,
          "total_price": this.totalPrice,
          "status": "done"
        }
        const response = await api.post(apiV2.busEmail, data, { needToken: true })
        if (response.status == 200) {
          this.$notify({
            group: 'saved',
            title: `Success`,
            text: 'Email has been sent!',
            type: 'success'
          });
          const response = await api.post(apiV2.notifySlack, data, { needToken: true });
        }
      })();
      this.toggleModal(index)
    },
    errorNotify(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
  .file-name {
    span {
      font-size: 12px;
      width: 100px;
      height: 16px;
      font-size: 12px;
      margin-top: 2px;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    i{
      margin-top: 3px;
      font-size: 16px;
      margin-left: 6px;
      color: #999999;
      cursor: pointer;
    }
  }

  
</style>